import us from '../../../defines';
import {reverseCLR, hexColortoRGB, toHexColor} from '../../../lib/utility/helpers';
import {createModel} from './model';

const lookupTable = {
  json (props, model) {
    Object.assign(model, props);
  },

  x2js (props, model) {
    model.Id = props._Id;
    model.Name = props._Name || model.Id;

    model.ImageId = Number(props.ImageId);

    model.ReadOnly = props._ReadOnly !== '0';
    model.NameReadOnly = props._NameReadOnly === '0';
    model.LineColorReadOnly = props._LineColorReadOnly === '0';
    model.Incremental = props._Incremental === '0';

    model.LineColor = props._LineColor;
    model.isVisible = props.hasOwnProperty('_Visible') ? Boolean(props._Visible) : true;
    model.Selected = props._Selected === '1';

    // InputAnnotationId is
    //  * defined for analysis output layers (except whole slide)
    //  * undefined for Annotation, Report, Input and whole slide output layer
    //  * 0 for a tuning layer
    model.InputAnnotationId = props.InputAnnotationId ? Number(props.InputAnnotationId) : undefined;

    // NOTE: Type is a layer attribute for tuning layers otherwise as a node (geez...)
    model.Type = Number(props._Type);

    // toconsider: when the type is aafresult, THEN a lot of these macro and input annot ids matter, so maybe if (aafresult type ) then { }

    model.MacroName = props._MacroName;
    // Set macroId. NOTE: Cindy originally pointed MacroId at MacroName (with the ID as a fallback value). This value
    // was actually being sent back to DataServer when annotations are saved. TODO: Was that done intentionally?
    model.MacroId = props.MacroId;

    if (props.Attributes_asArray.length) {
      const attrs = props.Attributes;
      for (let a = 0, alen = attrs.__cnt; a < alen; a++) {
        // e.g. <Attribute Name="Date" Id="728" Value="2014/06/03"/>  note that Id of attribute isn't useful
        /// ///////////////////ok on getannotations2 (dodbcall) for an aafresult layer
        //
        // Attribute: Array[62] and Attribute_asArray: Array[62] but ___cnt = 125
        // and then there is ___text: Array[63] is full of wierd character and space "↵                    "
        //
        // When I get the same layer with getannotations (imgserver call)
        // Attribute: Array[62] and Attribute_asArray: Array[62] and ___cnt = 62
        // and there is no ___text array
        //
        if (!attrs.Attribute[a]) {
          break; // TODO: is "break" appropriate here? Why not "continue"?
        }

        // todo: some attributes contain _DisplayColor as well..... (_Id too but who needs it?)
        let displayColor = attrs.Attribute[a]._DisplayColor | '';

        let colorRGB = `#${toHexColor(reverseCLR(displayColor))}`;
        if (colorRGB === '#000000') {
          colorRGB = '#FFFFFF';
        }
        model.attributes[attrs.Attribute[a]._Name] = {
          'value': attrs.Attribute[a]._Value,
          colorRGB
        };
      }
    }

    // Added for Analysis
    // build a region attribute Id to Name lookup table
    //        - inObj.Regions holds <RegionAttributeHeaders> with Id, Name;  The Id here is the Name in the Region.Attributes.Attribute items
    if (props.Regions && props.Regions.RegionAttributeHeaders) {
      const regAttrIdName = {};
      props.Regions.RegionAttributeHeaders.AttributeHeader.forEach(header => {
        if (!header) {
          return false;
        }
        regAttrIdName[header._Id] = header._Name;
      });
    }
  }
};

const updateCommonProps = (props, model) => {
  // if layer color was not defined, randomly select a color
  if (!model.LineColor) {
    const color = us.getRandomColor();
    model.LineColor = reverseCLR(hexColortoRGB(color));
  }
  model.typeName = getKeyFromValue(us.anLayerTypes, model.Type);
  model.isSupported = !!us.anLayerTypesSupported[model.Type];
};

const getKeyFromValue = (assocArray, value) => {
  for (var key in assocArray) {
    if (assocArray.hasOwnProperty(key)) {
      if (assocArray[key] == value) { return key; }
    }
  }
  return '';
};

export default (props, type) => {
  const model = createModel();

  const parser = lookupTable[type];
  if (parser) {
    parser(props, model);
  } else {
    throw new Error(`layer-factory::create() Cannot create layer from "${type}" base model`);
  }

  updateCommonProps(props, model);

  return model;
};



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/annotations/layer/model-factory.js